import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Plus, Building2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { OfferList } from '@/components/partner/OfferList';
import { AddOfferDialog } from '@/components/partner/AddOfferDialog';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useAuth } from '@/contexts/AuthContext';

export function PartnerDashboard() {
  const [showAddOffer, setShowAddOffer] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { t, dir } = useLanguage();
  const { userData } = useAuth();

  return (
    <div className="space-y-8" dir={dir}>
      <div>
        <div className="flex items-center gap-4 mb-2">
          <div className="relative">
            <Avatar className="h-[70px] w-[70px] bg-primary text-white border-none">
              <AvatarImage src={userData?.businessLogo} alt={userData?.businessName} className="object-cover" />
              <AvatarFallback className="bg-primary">
                <Building2 className="h-[34px] w-[34px]" />
              </AvatarFallback>
            </Avatar>
          </div>
          <div className="space-y-1">
            <h2 className="text-2xl font-bold tracking-tight">
              {userData?.businessName || t('dashboard.partner.dashboard.title')}
            </h2>
            <p className="text-muted-foreground">
              {t('dashboard.partner.dashboard.description')}
            </p>
          </div>
        </div>
      </div>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="relative flex-1 max-w-sm">
              <Search className={`absolute ${dir === 'rtl' ? 'right-3' : 'left-3'} top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground`} />
              <Input
                placeholder={t('dashboard.partner.dashboard.offers.search')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={dir === 'rtl' ? 'pr-9' : 'pl-9'}
              />
            </div>
            <Button onClick={() => setShowAddOffer(true)}>
              <Plus className={`h-4 w-4 ${dir === 'rtl' ? 'ml-2' : 'mr-2'}`} />
              {t('dashboard.partner.dashboard.offers.add')}
            </Button>
          </div>

          <OfferList searchQuery={searchQuery} />
        </CardContent>
      </Card>

      <AddOfferDialog
        open={showAddOffer}
        onOpenChange={setShowAddOffer}
        onSuccess={() => {}}
      />
    </div>
  );
}